import { render, staticRenderFns } from "./JsonDisplay.vue?vue&type=template&id=b4ab80aa&scoped=true"
import script from "./JsonDisplay.vue?vue&type=script&lang=js"
export * from "./JsonDisplay.vue?vue&type=script&lang=js"
import style0 from "./JsonDisplay.vue?vue&type=style&index=0&id=b4ab80aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ab80aa",
  null
  
)

export default component.exports